import { useEffect, useState } from "react";
import { roleIcons, symbolChoices, type Role } from "../../state/roles";
import { Sheet } from "../../ui/components";
import "./workspace.css";

/** 新建 / 编辑自定义角色。保存 undefined 表示删除。 */
export function RoleEditor({ role, onClose, onSave }: { role?: Role; onClose: () => void; onSave: (saved: Role | undefined, original: Role) => void }) {
  const [draft, setDraft] = useState<Role>();
  const [existed, setExisted] = useState(false);
  useEffect(() => {
    setDraft(role);
    setExisted(!!role && (role.name !== "" || role.persona !== ""));
  }, [role]);
  if (!role || !draft) return <Sheet open={false} onClose={onClose}>{null}</Sheet>;
  const canSave = draft.name.trim() !== "" && draft.persona.trim() !== "";
  const save = () => {
    const out = { ...draft, intro: draft.intro.trim() ? draft.intro : [...draft.persona].slice(0, 16).join("") };
    onSave(out, role);
    onClose();
  };
  return (
    <Sheet open onClose={onClose} title={existed ? "编辑角色" : "自定义角色"}
      leading={<button className="sheet-done" onClick={onClose}>取消</button>}
      trailing={<button className="sheet-done semibold" disabled={!canSave} onClick={save}>保存</button>}>
      <div className="form">
        <div className="form-card">
          <input className="form-inline" placeholder="角色名，例如：带货主播" value={draft.name} onChange={(e) => setDraft({ ...draft, name: e.target.value })} />
          <input className="form-inline" placeholder="一句话介绍（显示在卡片上）" value={draft.intro} onChange={(e) => setDraft({ ...draft, intro: e.target.value })} />
        </div>
        <div className="form-group">
          <span className="form-label">图标</span>
          <div className="symbol-grid">
            {symbolChoices.map((s) => {
              const Icon = roleIcons[s];
              const on = draft.symbol === s;
              return <button key={s} className={`symbol-choice${on ? " on" : ""}`} onClick={() => setDraft({ ...draft, symbol: s })} aria-pressed={on}><Icon size={18} /></button>;
            })}
          </div>
        </div>
        <label className="form-group">
          <span className="form-label">角色设定</span>
          <textarea className="form-field" rows={7} placeholder="它是谁、擅长什么、说话风格、需要注意什么…" value={draft.persona} onChange={(e) => setDraft({ ...draft, persona: e.target.value })} />
          <span className="t-caption t-2 form-hint">开始对话时会把这段设定发给它。只影响这一段对话，记忆和技能都是共用的。</span>
        </label>
        {existed && <button className="big-button danger" onClick={() => { onSave(undefined, role); onClose(); }}>删除这个角色</button>}
      </div>
    </Sheet>
  );
}
